import {
  HANDOVERLISTENGINEERING_LOADING,
  GET_HANDOVERLISTENGINEERING,
  GET_HANDOVERLISTENGINEERING_SUCCESS,
  GET_HANDOVERLISTENGINEERING_FAIL,
  ADD_HANDOVERLISTENGINEERING_SUCCESS,
  ADD_HANDOVERLISTENGINEERING_FAIL,
  DELETE_HANDOVERLISTENGINEERING_SUCCESS,
  DELETE_HANDOVERLISTENGINEERING_FAIL,
  UPDATE_HANDOVERLISTENGINEERING_SUCCESS,
  UPDATE_HANDOVERLISTENGINEERING_FAIL,
  HANDOVERLISTENGINEERING_RESET
} from "./actionType";

const INIT_STATE = {
  handoverListEngineerings: [],
  error: {},
};

const HandoverListEngineering = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_HANDOVERLISTENGINEERING_SUCCESS:
      switch (action.payload.actionType) {
        case GET_HANDOVERLISTENGINEERING:
          return {
            ...state,
            handoverListEngineerings: action.payload.data,
            isHandoverListEngineeringCreated: false,
            isHandoverListEngineeringUpdated: false,
            isHandoverListEngineeringSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_HANDOVERLISTENGINEERING_FAIL:
      switch (action.payload.actionType) {
        case GET_HANDOVERLISTENGINEERING_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isHandoverListEngineeringCreated: false,
            isHandoverListEngineeringUpdated: false,
            isHandoverListEngineeringSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_HANDOVERLISTENGINEERING: {
      return {
        ...state,
        isHandoverListEngineeringCreated: false,
        isHandoverListEngineeringUpdated: false,
        loading: true,
      };
    }

    case HANDOVERLISTENGINEERING_LOADING: {
      return {
        ...state,
        isHandoverListEngineeringCreated: false,
        isHandoverListEngineeringUpdated: false,
        loading: true,
      };
    }

    case ADD_HANDOVERLISTENGINEERING_SUCCESS:
      return {
        ...state,
        isHandoverListEngineeringCreated: true,
        loading: false,
        handoverListEngineerings: [action.payload.data, ...state.handoverListEngineerings],
      };

    case ADD_HANDOVERLISTENGINEERING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_HANDOVERLISTENGINEERING_SUCCESS:
      return {
        ...state,
        loading: false,
        handoverListEngineerings: state.handoverListEngineerings.filter(
          civilHandoverListEngineering => civilHandoverListEngineering.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_HANDOVERLISTENGINEERING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_HANDOVERLISTENGINEERING_SUCCESS:
      return {
        ...state,
        loading: false,
        isHandoverListEngineeringUpdated: true,
        handoverListEngineerings: state.handoverListEngineerings.map(civilHandoverListEngineering =>
          civilHandoverListEngineering.id.toString() === action.payload.data.id.toString() ? { ...civilHandoverListEngineering, ...action.payload.data } : civilHandoverListEngineering
        ),
      };

    case UPDATE_HANDOVERLISTENGINEERING_FAIL:
      return {
        ...state,
        loading: false,
        isHandoverListEngineeringUpdated: false,
        error: action.payload,
      };

    case HANDOVERLISTENGINEERING_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default HandoverListEngineering;